var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449.99999999999994,
    height: 525,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    rx: 25,
    id: "svg_1",
    height: 450,
    width: 235,
    y: 0,
    x: 0,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    height: 1,
    width: 1,
    y: 263,
    x: 906,
    stroke: "#000",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 25,
    id: "svg_7",
    height: 430,
    width: 215,
    y: 10,
    x: 10,
    strokeWidth: 0,
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    rx: 10,
    id: "svg_4",
    height: 36.33328,
    width: 189.33337,
    y: 288.99983,
    x: 22.83331,
    fill: "#71982d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "svg_9",
    y2: 244,
    x2: -8,
    y1: 146,
    x1: 178,
    stroke: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_13",
    height: 0,
    width: 1,
    y: 154,
    x: 146,
    strokeWidth: 0,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    d: "m140,286l-5,-17",
    opacity: "NaN",
    stroke: "null",
    fill: "#71982d"
  }), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Lato, sans-serif",
    fontSize: 10,
    id: "svg_20",
    y: 188.33332,
    x: 43.96087,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Book waste hauling and dropoff"), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Lato, sans-serif",
    fontSize: 12,
    id: "svg_33",
    y: 422.16536,
    x: 77.22393,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Sign In Here &gt;"), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    id: "svg_41",
    height: 100,
    width: 200,
    y: 63.50008,
    x: 17.5
  }), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Lato, sans-serif",
    fontSize: 10,
    id: "svg_42",
    y: 203.66667,
    x: 24.57543,
    strokeWidth: 0,
    fill: "#71982d"
  }, "service on the Trash Gurus marketplace."), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Lato, sans-serif",
    fontSize: 10,
    id: "svg_43",
    y: 235.00003,
    x: 44.71868,
    strokeWidth: 0,
    fill: "#71982d"
  }, "This is sustainability simplified."), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Lato, sans-serif",
    fontSize: 18,
    id: "svg_44",
    y: 313.33325,
    x: 41.67962,
    strokeWidth: 0,
    fill: "#ffffff"
  }, "Create an account"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "normal",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Lato, sans-serif",
    fontSize: 10,
    id: "svg_45",
    y: 401.00019,
    x: 58.17442,
    strokeWidth: 0,
    fill: "#71982d"
  }, "Already have an account?"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("title", {
    stroke: "null"
  }, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ffffff",
    x: 211.67267,
    y: 113.6667,
    width: 210.68669,
    height: 393.99996,
    id: "svg_74",
    rx: 25
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    fill: "#fff",
    x: 1023.93709,
    y: 343.93778,
    width: 0.89654,
    height: 0.87556,
    id: "svg_73"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#eaeaea",
    strokeWidth: 0,
    x: 220.63806,
    y: 122.42225,
    width: 192.7559,
    height: 376.48885,
    id: "svg_72",
    rx: 25
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#71982d",
    x: 220.63806,
    y: 122.42225,
    width: 127.30855,
    height: 83.17777,
    id: "svg_71",
    rx: 25
  }), /*#__PURE__*/React.createElement("text", {
    stroke: "#ffffff",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#ffffff",
    x: 131.37106,
    y: 100.04393,
    id: "svg_70",
    strokeWidth: 0,
    fontSize: 24,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "Hi, Jane!"), /*#__PURE__*/React.createElement("line", {
    stroke: "null",
    fill: "none",
    x1: 371.25663,
    y1: 241.4978,
    x2: 204.50036,
    y2: 327.30223,
    id: "svg_69"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ffffff",
    strokeWidth: 0,
    x: 239.01712,
    y: 174.95558,
    width: 164.9632,
    height: 93.68443,
    id: "svg_68",
    rx: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0,
    stroke: "null",
    fill: "#ffffff",
    strokeWidth: 0,
    x: 342.56738,
    y: 248.50224,
    width: 0.89654,
    id: "svg_67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#71982d",
    opacity: "NaN",
    d: "m337.18815,364.07556l-4.4827,-14.88444",
    id: "svg_66"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#b5d677",
    strokeWidth: 0,
    x: 238.56885,
    y: 174.95558,
    width: 44.82695,
    height: 43.77777,
    id: "svg_65",
    rx: 15
  }), /*#__PURE__*/React.createElement("text", {
    stroke: "#ffffff",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#ffffff",
    strokeWidth: 0,
    x: 149.37107,
    y: 153.54394,
    id: "svg_64",
    fontSize: 24,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "bold"
  }, "35"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 129.37106,
    y: 252.04393,
    id: "svg_63",
    fontSize: 16,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "bold"
  }, "Select A Service"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ffffff",
    strokeWidth: 0,
    x: 229.60346,
    y: 301.91112,
    width: 179.30782,
    height: 43.77777,
    id: "svg_62",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ffffff",
    strokeWidth: 0,
    x: 229.60346,
    y: 349.19112,
    width: 179.30782,
    height: 43.77777,
    id: "svg_61",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ffffff",
    strokeWidth: 0,
    x: 229.60346,
    y: 396.47111,
    width: 179.30782,
    height: 43.77777,
    id: "svg_60",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ffffff",
    strokeWidth: 0,
    x: 229.60346,
    y: 445.06444,
    width: 179.30782,
    height: 43.77777,
    id: "svg_59",
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 140.37106,
    y: 287.04393,
    id: "svg_58",
    fontSize: 18,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "Junk Removal"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 140.37106,
    y: 342.04393,
    id: "svg_57",
    fontSize: 18,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "Dumpster Rental"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 140.37106,
    y: 395.04393,
    id: "svg_56",
    fontSize: 18,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "Document Shredding"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 140.37106,
    y: 451.04393,
    id: "svg_55",
    fontSize: 18,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "Curbside Trash"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 139.87107,
    y: 304.04393,
    id: "svg_54",
    fontSize: 12,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "22 Local Options"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 141.12124,
    y: 358.04284,
    id: "svg_53",
    fontSize: 12,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "15 Yard  -  20 Yard  -  30 Yard"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 141.12124,
    y: 411.54273,
    id: "svg_52",
    fontSize: 12,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "Pricing by the pound"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 141.62123,
    y: 466.54262,
    id: "svg_51",
    fontSize: 12,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve"
  }, "32 Gallon  -  96 Gallon"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 196.37092,
    y: 151.04414,
    id: "svg_50",
    fontSize: 14,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "bold"
  }, "Recent Jobs"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 150.87101,
    y: 185.54407,
    id: "svg_49",
    fontSize: 10,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "normal"
  }, "Helping you get rid of"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 151.37101,
    y: 200.04404,
    id: "svg_48",
    fontSize: 10,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "normal"
  }, "just about anything"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 196.37092,
    y: 151.04414,
    id: "svg_47",
    fontSize: 14,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "bold"
  }, "Recent Jobs"), /*#__PURE__*/React.createElement("text", {
    stroke: "null",
    transform: "matrix(0.896539 0 0 0.875555 112.721 70.726)",
    fill: "#71982d",
    strokeWidth: 0,
    x: 207.37092,
    y: 216.04408,
    id: "svg_46",
    fontSize: 8,
    fontFamily: "Lato, sans-serif",
    textAnchor: "start",
    xmlSpace: "preserve",
    fontWeight: "bold"
  }, "Learn More &gt;"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImg2);
export default __webpack_public_path__ + "static/media/hero-img-2.d611c67bed8112795cb6e442fa5838ad.svg";
export { ForwardRef as ReactComponent };